export interface IPositionCoordinator {
    position: number,
    donorCoordinator: ICoordinatorDetail,
    recipientCoordinator: ICoordinatorDetail
}

export interface ICoordinatorDetail {
    contactId: number,
    email: string,
    fullName: string,
    phoneNumber: string,
    centerAlias: string,
}